import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const CodeHighlight = ({ text, size = 'small' }) => {
    const theme = useTheme();

    return (
        <Typography sx={{
            fontFamily: 'monospace',
            fontSize: size,
            background: theme.palette.background.paper,
            pl: 0.75,
            pr: 0.75,
            pt: 0.25,
            pb: 0.25,
            borderRadius: 1,
            display: 'inline-block',
            ml: 1,
            mr: 1
        }}>
            {text}
        </Typography>
    );
};

export default CodeHighlight;
